<template>
  <div class="people">
    <div class="topBox">
      <p>人员检索:<Input v-model="userName" placeholder="输入人员名称" style="width:200px"/></p>
      <Button type="primary" class="basicBtn" custom-icon="iconfont icon-sousuo1" @click="search">搜索</Button>
      <Button type="primary" class="basicBtn" custom-icon="iconfont icon-jia" @click="addAccount">新建账号</Button>
    </div>
    <div class="mainBox">
       <Table :height="tableHeight" ref="table" :columns="columns1" :data="data1" highlight-row></Table>
       <div class="pageBox">
         <Page :total="total" :transfer='true' show-elevator show-sizer @on-change="changePage" @on-page-size-change="changePageSize"/>
       </div>
    </div>
    <Modal 
    class="infoModal"
        :name="modelName"
        v-model="modal1"
        :title="modelTitle"
        @on-ok="ok"
        @on-cancel="cancel">
        <p><Icon :custom="modeIcon" :color="iconColor"></Icon> {{modelContent}}</p>
    </Modal>
    <Modal 
        width="60%"
        :name="modelName"
        v-model="modal2"
        :title="modelTitle"
        @on-ok="confirm"
        @on-cancel="cancel">
        <div class="accountBox">
          <ul>
            <li>
              <p><span class="redsize">手机号:</span></p>
              <p>
                <Input v-model="phone" placeholder="手机号" style="width: 300px" />
                <span class="block">手机号登录即为登录账号，新建账号默认密码均为手机号后六位，用户登录后需修改初始密码!</span>
              </p>
            </li>
            <li>
              <p><span class="redsize">真实姓名:</span></p>
              <Input v-model="realName" placeholder="姓名" style="width: 300px" />
            </li>
            <li>  
              <p><span class="redsize">性别:</span></p>
              <RadioGroup v-model="sex">
                <Radio :label="item.value" v-for="(item,index) in sexList" v-bind:key="index">{{item.label}}</Radio>
                <!-- <Radio label="女"></Radio> -->
              </RadioGroup>
            </li>
            <li>  
              <p><span>医生标记:</span></p>
              <RadioGroup v-model="doctorMark">
                <Radio v-for="(item,index) in docMarkList" v-bind:key="index" :label="item.value">{{item.label}}</Radio>
              </RadioGroup>
            </li>
            <li>  
              <p><span class="redsize">科室:</span></p>
                <Select v-model="clinic" style="width:200px">
                  <Option v-for="item in clinicList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </li>
            <li>  
              <p><span class="redsize">挂号费:</span></p>
              <Input v-model="registrFee" placeholder="挂号费" style="width: 300px" />
            </li>
            <li>  
              <p><span class="redsize">PC端角色:</span></p>
              <p>
                <label v-for="(item,index) in pcRole" v-bind:key="index" @click="selectPcRole(item)"><i class="iconfont" :class="{'icon-xuanzhong':item.isSelect,'icon-weixuanzhong2':!item.isSelect}"></i>{{item.name}}</label>
                <!-- <span><i class="iconfont icon-weixuanzhong2"></i>管理员</span> -->
              </p>
            </li>
            <li> 
              <p><span class="redsize">微信端角色:</span></p>
              <p>
                <label v-for="(item,index) in wechatRole" v-bind:key="index" @click="selectWXRole(item)"><i class="iconfont" :class="{'icon-xuanzhong':item.isSelect,'icon-weixuanzhong2':!item.isSelect}"></i>{{item.name}}</label>
                <!-- <span><i class="iconfont icon-weixuanzhong2"></i>管理员</span> -->
              </p>
            </li>
            <li>  
              <p><span class="redsize">状态:</span></p>
              <RadioGroup v-model="status">
                <Radio :label="item.value" v-for="(item,index) in statusList" v-bind:key="index">{{item.label}}</Radio>
                <!-- <Radio label="停用"></Radio> -->
              </RadioGroup>
            </li>
          </ul>
        </div>
        <div slot="footer">
            <Button type="text" size="large" @click="cancel">取消</Button>
            <Button type="primary" size="large" @click="confirm">确定</Button>
        </div>
    </Modal>
  </div>
</template>

<script>
import { 
  peopleList,savePeople,
  peopleDetail,updPeopleInfo,
  roleSelect,clinicList,
  pwdReset,deletePeople 
} from "./../../api/system";
import { 
  clinicSelList
} from "./../../api/appoint";
import { tips } from "../../tools";
export default {
  name: 'PeopleManager',
  data () {
    return {
      tableHeight:622,
      // pcRole:'医生',
      // wechatRole:'管理员',
      editId:0,
      resetId:0,
      deleteId:0,
      wechatSelRole:[],
      wechatRole:[],//微信角色展示
      pcRole:[],//pc角色展示
      pcSeltRole:[],
      isSelect:true,//角色选中
      status:1,//状态
      statusList:[
        {
          value:1,
          label:'启用'
        },
        {
          value:0,
          label:'未启用'
        }
      ],
      total:0,
      pageCurrent:1,
      pageSize: 10,
      peopleStatus:1,
      peopleStatusList:[
        {
          label:'已启用',
          value:1
        },
        {
          label:'未启用',
          value:0
        }
      ],
      
      registrFee:'',//挂号费
      clinic:'',//科室
      clinicList:[],
      doctorMark:1,
      docMarkList:[
        {
          label:'是',
          value:1
        },
        {
          label:'否',
          value:0
        }
      ],
      phone:'',
      sex:1,
      sexList:[
        {
          value:1,
          label:'男'
        },
        {
          value:2,
          label:'女'
        }
      ],
      realName:'',//真实姓名
      modelName:'',
      modeIcon:'',
      iconColor:'',
      modelTitle:'',
      modelContent:'',
      userName:'',
      modal1:false,
      modal2:false,
      columns1:[
        {   
            title: '姓名',
            key: 'name',
            align:'center'
        },
        {
            title: '手机号',
            key: 'mobile',
            align:'center'
        },
        {
          title: '性别',
          key: 'sex',
          align:'center',
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps: {
                innerHTML: params.row.sex==1?'男':'女' 
              },
            })
          }
        },
        {
            title: '科室',
            key: 'departmentName',
            align:'center'
        },
        {
            title: '挂号费',
            key: 'registrationFee',
            align:'center'
        },
        {
            title: 'PC端角色名称',
            key: 'pcHosptailRoleName',
            align:'center'
        },
        {
            title: '微信端角色名称',
            key: 'wxHosptailRoleName',
            align:'center'
        },
        {
          title: '状态',
          key: 'enabled',
          align:'center',
          // params.row.enabled=='1'?'已使用':'未使用' 
          render:(h,params) => {
            return h('div',{
              style: {
                textAlign: 'center',
              },
              domProps:{
                innerHTML:params.row.enabled=='1'?'已启用':'未启用' 
              }
            },
            // [
            //   h('i-switch',{
            //     props:{
            //       custom:'iconfont icon-duihao',
            //       value:params.row.enabled==1?true:false 
            //     },
            //     style:{
            //       textAlign:'center'
            //     },
            //     on:{
            //       'on-change': (value) => {
            //         console.log(value)
            //         let id = params.row.id;
            //         let enabled = 0;
            //         switch(value){
            //           case true:
            //             enabled = 1;
            //             break;
            //           case false:
            //             enabled = 0;
            //         }
            //         this.changeSwitch(id,enabled);
            //       }
            //     }
            //   })
            // ]
            )
          }
        },
        {
          width:240,
          title: '操作',
          align:'center',
          key: 'methods',
          align: 'center',
          // maxWidth:170,
          render: (h, params) => {
            return h('div',{
              style: {
                  textAlign: 'center',
                  display:'flex',
                  flexFlow:'wrap row'
                }
              },
              [
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-bianji'
                  },
                  style: {
                    textAlign:'center',
                    margin:' 0 5px 0',
                    borderColor:'#2778E7',
                    color:'#2778E7'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      this.modal2 = true;
                      this.modelName = 'editAccount';
                      this.modelTitle = '修改账户';
                      // this.phone = '';
                      // this.realName = '';
                      // this.registrFee = '';
                      console.log(params.row.id);
                      let queId = params.row.id;
                      this.editId = queId;
                      this.departmentList();
                      this.roleSelect(1);
                      this.roleSelect(3);
                      this.userDetail(queId);
                    }
                  }
                }, '修改'),
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-shuaxin'
                  },
                  style: {
                    textAlign:'center',
                    marginRight:'5px',
                    borderColor:'#2778E7',
                    color:'#2778E7'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      this.modal1 = true;
                      this.modelName = 'pswdReset';
                      this.modelTitle = '系统提示';
                      this.modelContent = '是否确认将该人员密码重置为初始密码?';
                      this.modeIcon = ' iconfont icon-Group-';
                      this.iconColor='#2778E7';
                      this.resetId = params.row.id;

                    }
                  }
                }, '密码重置'),
                h('Button', {
                  props: {
                    // type: 'error',
                    size: 'small',
                    ghost:true,
                    type:'info',
                    customIcon:'iconfont icon-shanchu'
                  },
                  style: {
                    textAlign:'center',
                    borderColor:'#C9C9C9',
                    color:'#595757'
                  },
                  'class':{

                  },
                  on: {
                    click: () => {
                      this.modal1 = true;
                      this.modelName = 'delete';
                      this.modelTitle = '系统提示';
                      this.modelContent = '是否确认删除该人员?此操作不可逆';
                      this.modeIcon = ' iconfont icon-Group-';
                      this.iconColor='#FE6E6E';
                      this.deleteId = params.row.id;
                    }
                  }
                }, '删除')
            ]);
          }
        }
      ],
      data1:[
        {
          phone: '18487895464',
          username: 18,
          sex:'男',
          departmentName: '全科',
          registrFee: '2016-10-03',
          status: '启用',
          system: ''
        },
      ]
    }
  },
  created(){
    let lett = this;
    document.onkeydown = function(e) {
    let key = window.event.keyCode;
    if (key == 13) {
      lett.search();
      }
    }
  },
  mounted(){
    window.addEventListener('resize', this.getTableHeight);
    this.getTableHeight();
    this.getUrl();
    this.loadList();
  },
  methods:{
    getTableHeight(){
      // 设置表格高度 
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop-60; 
    }, 
    getUrl(){
      let _this=this;
      var url = location.href; //获取url中"?"符后的字串    
      var theRequest = new Object();  
//						console.log(url);
        if (url.indexOf("?") != -1) {   
          var str = url.substr(url.indexOf("?")+1);  
//				console.log(str);
          let strs = str.split("&");  
          for(var i = 0; i < strs.length; i ++) {   
              theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);   
          } 
        }   
        console.log(theRequest);
    },
    loadList(){
      this.search();
    },
    ok(){
      switch(this.modelName){
        case 'pswdReset':
          pwdReset({
            id:this.resetId
          }).then(res => {
            console.log(res);
            tips(this, res, "success");
            this.loadList();
          });
          break;
        case 'delete':
          deletePeople({
            id:this.deleteId
          }).then(res => {
            console.log(res);
            tips(this, res, "success");
            this.loadList();
          })
          break;
      }
    },
    cancel(){
      this.modal2 = false;
    },
    //搜索
    search(){
      peopleList({
        current: this.pageCurrent,
        enabled: this.peopleStatus,
        name: this.userName,
        size: this.pageSize
      }).then(res => {
        console.log(res);
        this.data1 = res.records;
        this.total = res.total;
      });
    },
    //查询角色下拉
    roleSelect(catrgory){
      let _this = this;
      
      roleSelect({
        catrgory: catrgory,
      }).then(res => {
        console.log(res);
        switch(catrgory){
          //pc
          case 1:
            let arr = [];
            res.forEach(item => {
              let obj={
                id:'',
                name:'',
                isSelect:false
              }
              obj.id = item.id;
              obj.name = item.name;
              arr.push(obj);
            });
            console.log(arr)
            _this.pcRole = arr;
            break;
          //wechat
          // _this.wechatRole
          case 3:
            let wxarr = [];
            res.forEach(item => {
              let obj={
                id:'',
                name:'',
                isSelect:false
              }
              obj.id = item.id;
              obj.name = item.name;
              wxarr.push(obj);
            });
            console.log(wxarr)
            _this.wechatRole = wxarr;
            break;
        }
      });
    },
    //根据id查询用户
    userDetail(id){
      let _this = this;
      peopleDetail({
        id:id
      }).then(res => {
        console.log(res);
        console.log(_this.wechatRole);
        console.log(_this.pcRole);
        _this.phone = res.mobile;
        _this.realName = res.name;
        _this.sex = res.sex;
        _this.doctorMark = res.doctorFlag;
        _this.clinic = res.departmentId;
        _this.registrFee = res.registrationFee;
        _this.status = res.enabled;
        console.log(_this.pcRole);
        if(res.hisRoleVos.length>0){
          //pc角色展示
          for(let i =0;i<res.hisRoleVos.length;i++){
            let pcIndex = _this.pcRole.findIndex(target=>target.id==res.hisRoleVos[i].id);
            console.log(pcIndex)
            console.log(_this.pcRole)
            _this.pcRole[pcIndex].isSelect = true;
          }
        }
        console.log(_this.wechatRole)
        if(res.wxhisRoleVos.length>0){
          //微信角色展示
          for(let j =0;j<res.wxhisRoleVos.length;j++){
            let wxIndex = _this.wechatRole.findIndex(target=>target.id==res.wxhisRoleVos[j].id);
            console.log(wxIndex)
            if(wxIndex!=-1){
              _this.wechatRole[wxIndex].isSelect = true;
            }
          }
        }
        
        let pcArr = [];
        let wechatRole = this.wechatRole; 
        console.log(wechatRole)
        for(let i=0;i<wechatRole.length;i++){
          if(wechatRole[i].isSelect==true){
            pcArr.push(wechatRole[i].id)
          }
          // wechatSelRole
          console.log(pcArr);
          _this.wechatSelRole = pcArr;
        }
        let wxArr = [];
        let pcRole = _this.pcRole; 
        console.log(pcRole)
        for(let i=0;i<pcRole.length;i++){
          if(pcRole[i].isSelect==true){
            wxArr.push(pcRole[i].id)
          }
          // pcSeltRole
          console.log(wxArr);
          _this.pcSeltRole = wxArr;
        }
      });
    },
    //查询科室下拉
    departmentList(){
      let _this = this;
      clinicSelList({
      }).then(res => {
        console.log(res);
        let arr= [];
        res.forEach(item => {
          let obj={
            value:'',
            label:''
          }
          obj.value = item.id;
          obj.label = item.departmentName;
          arr.push(obj);
        });
        this.clinicList = arr;
      });
    },
    //角色选中
    selectPcRole(data){
      console.log(data)
      if(data.isSelect){
        data.isSelect = false;
      }else{
        data.isSelect = true;
      }
      let arr = [];
      let pcRole = this.pcRole; 
      console.log(pcRole)
      for(let i=0;i<pcRole.length;i++){
        if(pcRole[i].isSelect==true){
          arr.push(pcRole[i].id)
        }
        // pcSeltRole
        console.log(arr);
        this.pcSeltRole = arr;
      }
      console.log(arr);
    },
    selectWXRole(data){
      console.log(data)
      if(data.isSelect){
        data.isSelect = false;
      }else{
        data.isSelect = true;
      }
      let arr = [];
      let wechatRole = this.wechatRole; 
      console.log(wechatRole)
      for(let i=0;i<wechatRole.length;i++){
        if(wechatRole[i].isSelect==true){
          arr.push(wechatRole[i].id)
        }
        // wechatSelRole
        console.log(arr);
        this.wechatSelRole = arr;
      }
    },
    //新增账号
    addAccount(){
      this.modal2 = true;
      this.modelName = 'newAccount';
      this.modelTitle = '新建账户';
      this.departmentList();
      this.roleSelect(1);
      this.roleSelect(3);
      this.phone = '';
      this.realName = '';
      this.registrFee = '';
    },
    //确认新建
    confirm(){
      console.log(this.wechatSelRole);
      console.log(this.pcSeltRole);
      this.modal2 = true;
      if(!this.pcSeltRole.length>0){
        tips(this, "PC端角色必须选择一个！","warning");
      }else if(!this.wechatSelRole.length>0){
         tips(this, "微信端角色必须选择一个！","warning");
      }else{
        if(this.modelName == 'editAccount'){
          updPeopleInfo({
            id:this.editId,
            mobile: this.phone,
            name: this.realName,
            sex: this.sex,
            registrationFee:this.registrFee,
            enabled:this.status,
            roles:this.pcSeltRole,
            wxroles:this.wechatSelRole,
            departmentId:this.clinic,
            doctorFlag:this.doctorMark
          }).then(res => {
            this.modal2 = false;
            console.log(res);
            tips(this, res, "success");
            this.loadList();
          })
        }else if(this.modelName == 'newAccount'){
          savePeople({
            mobile: this.phone,
            name: this.realName,
            sex: this.sex,
            registrationFee:this.registrFee,
            enabled:this.status,
            roles:this.pcSeltRole,
            wxroles:this.wechatSelRole,
            departmentId:this.clinic,
            doctorFlag:this.doctorMark
          }).then(res => {
            console.log(res);
            tips(this, res, "success");
            this.modal2 = false;
            this.loadList();
          });
        }
      }
    },
    //改变状态
    changeSwitch(id,enabled){
      peopleStatus({
        id:id,
        enabled:enabled
      }).then(res => {
        console.log(res);
        tips(this, res, "success");
        this.loadList();
      });
    },
    //改变页码
    changePage(current){
      this.pageCurrent = current;
      this.loadList();
    },
    //改变每页条数
    changePageSize(size){
      this.pageSize = size;
      this.loadList();
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.people{
  height: 100%;
  padding: 10px;
}
.topBox{
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap row;
  padding-bottom:10px;
}
.topBox>p{
  font-size: 14px;
  margin-right: 15px;
}
.topBox>p>div{
  margin-left: 10px;
}
.topBox button{
  margin-left: 10px;
}
.pageBox{
  text-align: center;
  padding: 5px 0;
}
.ivu-modal-body p{
  font-size: 14px;
}
/* 新建账户框 */
.accountBox>ul>li{
  display: flex;
  justify-content: baseline;

}
.accountBox>ul>li>p:first-child{
  width: 150px;
  height: 41px;
  padding-right: 10px;
}
.accountBox>ul>li>.ivu-radio-group{
  padding: 0;
}
.accountBox>ul>li>div{
  padding: 5px 0;
}
.accountBox>ul>li>p{
  line-height: 41px;
}
.accountBox>ul>li>p>label>i{
  color:#1955A8;
  margin-right: 5px;
  cursor: pointer;
}
.accountBox>ul>li>p>span:first-child{
  display: inline-block;
  padding-left: 10px;
  float: right;
}
.accountBox>ul>li>p>span.block{
  display: block;
  color: #FE6E6E;
}
div.ivu-radio-group>label{
  line-height: 41px;
}

</style>



// WEBPACK FOOTER //
// src/views/system/PeopleManager.vue